import i18n from '@/i18n'
import Store from '@/store'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'
import { dateFormat } from '@/Utils/fliter'

const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, data, vm, titleData) => {
    try {
      // Loading
      Store.commit('mutateCommonProperties', {
        loading: true
      })

      // Translation
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }

      // API Call
      const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)

      // PDF
      const pdfContent = []

      //
      pdfContent.push(
        {
          table: {
            style: 'tableData',
            headerRows: 0,
            widths: ['25%', '50%', '25%'],
            body: [
              [
                { image: reportHeadData.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
                { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                { image: reportHeadData.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
              ],
              [
                {},
                { text: vm.$t('social_service.dss'), style: 'header2', alignment: 'center' },
                {}
              ],
              [
                {},
                {},
                {}
              ],
              [
                {},
                { text: reportHeadData.address, style: 'address', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportTitle, style: 'address2', alignment: 'center' },
                {}
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        }
      )

      //
      pdfContent.push(
        {
          table: {
            style: 'tableData',
            headerRows: 0,
            widths: ['50%', '50%'],
            body: [
              [
                { text: vm.$t('report.year') + ' : ' + titleData.year, style: 'td', alignment: 'left' },
                { text: vm.$t('social_service.hospital') + ' : ' + titleData.hosName, style: 'td', alignment: 'right' }
              ],
              [
                { text: vm.$t('report.month_name') + ' : ' + titleData.monthName, style: 'td', alignment: 'left' },
                { }
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        }
      )

      // Empty Space
      pdfContent.push(
        { text: '', style: 'empty_space' }
      )

      const allRowsHead = [
        [
          { text: vm.$t('report.income_first'), colSpan: 5, style: 'th', alignment: 'center' },
          {},
          {},
          {},
          {},
          { text: vm.$t('report.expenses'), colSpan: 6, style: 'th', alignment: 'center' },
          {},
          {},
          {},
          {},
          {}
        ],
        [
          { text: vm.$t('report.sl_no'), style: 'th', alignment: 'center' },
          { text: vm.$t('report.date'), style: 'th', alignment: 'center' },
          { text: vm.$t('report.description'), style: 'th', alignment: 'center' },
          { text: vm.$t('report.hand_deposite'), style: 'th', alignment: 'center' },
          { text: vm.$t('report.bank_deposote'), style: 'th', alignment: 'center' },
          { text: vm.$t('report.sl_no'), style: 'th', alignment: 'center' },
          { text: vm.$t('report.voucher_no'), style: 'th', alignment: 'center' },
          { text: vm.$t('report.date'), style: 'th', alignment: 'center' },
          { text: vm.$t('report.description'), style: 'th', alignment: 'center' },
          { text: vm.$t('report.cost_expenses'), style: 'th', alignment: 'center' },
          { text: vm.$t('report.withdraw_bank'), style: 'th', alignment: 'center' }
        ]
      ]
      data.map((report, index) => {
        allRowsHead.push(
        [
          { text: vm.$n(report.incomeSerial), style: 'td', alignment: 'center' },
          // { text: report.incomeDate, style: 'td', alignment: 'left' },
          { text: dateFormat(vm.rowDate), style: 'td', alignment: 'left' },
          { text: report.incomeDesc === 'ancestor' ? vm.$t('report.ancestor') : report.incomeDesc === 'deposit' ? vm.$t('report.bank_deposit_cash') : report.incomeDesc === 'withdraw' ? vm.$t('report.withdraw') : '', style: 'td', alignment: 'center' },
          { text: vm.$n(report.incomeHand), style: 'td', alignment: 'left' },
          { text: vm.$n(report.incomeBank), style: 'td', alignment: 'left' },
          { text: vm.$n(report.expenseSerial), style: 'td', alignment: 'left' },
          { },
          { text: dateFormat(report.expenseDate), style: 'td', alignment: 'left' },
          { text: report.expenseDesc === 'withdraw' ? vm.$t('report.withdraw') : report.expenseDesc === 'expense' ? vm.$t('report.expense') : '', style: 'td', alignment: 'left' },
          { text: vm.$n(vm.cost), style: 'td', alignment: 'left' },
          { text: vm.$n(vm.bankCharge), style: 'td', alignment: 'left' }
        ])
      })
      pdfContent.push({
        table: {
          headerRows: 0,
          widths: ['7%', '9%', '9%', '9%', '9%', '9%', '9%', '9%', '12%', '12%', '10%'],
          body: allRowsHead
        }
      })

      const allRowsHead2 = [
        // [
        //   { text: vm.$t('report.sl_no'), style: 'th', alignment: 'center' },
        //   { text: vm.$t('report.date'), style: 'th', alignment: 'center' },
        //   { text: vm.$t('report.description'), style: 'th', alignment: 'center' },
        //   { text: vm.$t('report.hand_deposite'), style: 'th', alignment: 'center' },
        //   { text: vm.$t('report.bank_deposote'), style: 'th', alignment: 'center' },
        //   { text: vm.$t('report.sl_no'), style: 'th', alignment: 'center' },
        //   { text: vm.$t('report.voucher_no'), style: 'th', alignment: 'center' },
        //   { text: vm.$t('report.date'), style: 'th', alignment: 'center' },
        //   { text: vm.$t('report.description'), style: 'th', alignment: 'center' },
        //   { text: vm.$t('report.cost_expenses'), style: 'th', alignment: 'center' },
        //   { text: vm.$t('report.withdraw_bank'), style: 'th', alignment: 'center' }
        // ]
      ]
        allRowsHead2.push(
        [
          { },
          { },
          { text: vm.$t('--'), style: 'th', alignment: 'center' },
          { },
          { },
          { },
          { },
          { },
          { text: vm.$t('--'), style: 'th', alignment: 'center' },
          { },
          { }
        ],
        [
          { },
          { },
          { text: vm.$t('--'), style: 'th', alignment: 'center' },
          { },
          { },
          { },
          { },
          { },
          { text: vm.$t('report.total'), style: 'th', alignment: 'center' },
          { text: vm.$n(vm.monthExpense), style: 'td', alignment: 'left' },
          { text: vm.$n(vm.monthWithdraw), style: 'td', alignment: 'left' }
        ],
        [
          { },
          { },
          { text: vm.$t('--'), style: 'th', alignment: 'center' },
          { },
          { },
          { },
          { },
          { text: vm.$t('report.hand_bank'), style: 'th', alignment: 'center', colSpan: 2 },
          { },
          { text: vm.$n(vm.monthWithdraw + vm.handAncester - vm.monthExpense), style: 'td', alignment: 'left' },
          { text: vm.$n(vm.bankAncester + vm.monthDeposit - vm.monthWithdraw - vm.bankCharge), style: 'td', alignment: 'left' }
        ],
        [
          { },
          { },
          { text: vm.$t('report.in_total'), style: 'th', alignment: 'center' },
          { text: vm.$n(vm.monthWithdraw + vm.handAncester), style: 'td', alignment: 'left' },
          { text: vm.$n(vm.bankAncester + vm.monthDeposit), style: 'td', alignment: 'left' },
          { },
          { },
          { text: vm.$t('report.in_total'), style: 'th', alignment: 'center', colSpan: 2 },
          { },
          { text: vm.$n(vm.monthWithdraw + vm.handAncester + vm.cost), style: 'td', alignment: 'left' },
          { text: vm.$n(vm.bankAncester + vm.monthDeposit), style: 'td', alignment: 'left' }
        ])
      pdfContent.push({
        table: {
          headerRows: 0,
          widths: ['7%', '9%', '9%', '9%', '9%', '9%', '9%', '9%', '12%', '12%', '10%'],
          body: allRowsHead2
        }
      })
      var docDefinition = {
      content: pdfContent,
      pageSize: 'A4',
      pageOrientation: 'landscape',
      styles: {
          th: {
            fontSize: 10,
            margin: [3, 3, 3, 3]
          },
          th1: {
              fontSize: 9
            },
          td: {
            fontSize: 8,
            margin: [3, 3, 3, 3]
          },
          header: {
            margin: [0, 1, 0, 15],
            fontSize: 16,
            alignment: 'center'
          },
          header2: {
            border: 0,
            fontSize: 14,
            margin: [0, 0, 0, 1]
          },
          govt_info: {
            margin: [0, 1, 0, 1],
            fontSize: 18,
            alignment: 'center'
          },
          address2: {
            border: 0,
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 5]
          },
          left_logo: {
            borderRadius: 50
          },
          empty_space: {
            margin: [10, 10, 10, 10]
          }
        }
      }
      pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
      if (error) {
        //
      }
    }

    // Loading Complete
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}

export default {
  exportPdfDetails
}
